window._ = require('lodash');



// WEBPACK FOOTER //
// ./app/assets/granite/js/lodash.js